import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { State } from '#types/state.type';

import { Uri } from '#constants/uri';

/**
 * Fetches a list of states from the API using the provided KyInstance.
 *
 * @param instance - The KyInstance used to make the HTTP request.
 * @returns A promise that resolves to an `OperationResultWithData` containing an array of `State` objects.
 * @throws Throws an error if the request fails.
 */
export const getStates = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<State[]>>(Uri.lookup.states).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
